import React, { useState, Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Space, Button, Row, Col, Typography, Form, message, Spin } from 'antd';
import InputForm from '../components/InputForm';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addMerchant } from "../../ducks/services"
import { getMerchantOption } from '../../ducks/actions'
import { useTranslate } from 'Translate';

const _ = require('lodash');
const { Title, Text } = Typography;

export default (props) => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.systems.merchantOptions);
  const navigate = useNavigate();
  const { control, handleSubmit, formState: { errors } } = useForm();
  const i18n = useTranslate();
  const { t } = i18n;

  useEffect(() => {
    dispatch(getMerchantOption(props.setLoading))
  }, [])

  const onFinish = async (val) => {
    props.setLoading(true);

    const payload = {
      store_name: val?.store_name,
      email: val?.email,
      merchant_type: val?.merchant_type.value
    }
    await addMerchant(payload).then(res => {
      props.setLoading(false);
      if(res.data.code === 200) {
        message.success(t("Success.create_merchant"));
        setTimeout(() => navigate("/merchant"), 500);
      }else{
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col flex='auto'>
              <Title level={3} className='mb-0 mt-0'>{t("New.merchant")}</Title>
            </Col>
            <Col flex='auto' className='text-right'>
              <Space size={10}>
                <Button size="large" htmlType='submit' className='green-btn'>{t("General.save")}</Button>
                <Button size="large" htmlType='button' className='red-btn text-white' onClick={() => navigate('/merchant')}>{'<'} {t("General.back")}</Button>
              </Space>
            </Col>
          </Row>
        </Col>
        <InputForm
          control={control}
          errors={errors}
          options={options}
          allowedEdit={true}
          allowedSave={true}
        />
      </Row>
    </Form>
  )
}